import { ButtonGroup, COLOR, font, mixins, textStyles } from '@cosuno/cosuno-ui';
import { Form } from '@cosuno/form';
import styled from 'styled-components';

export const StyledFormElement = styled(Form.Element)`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const TopHint = styled.span`
  ${textStyles.bodyMedium450}
  color: ${COLOR.textTertiary}
`;

export const BackContainer = styled(ButtonGroup)`
  margin-bottom: 30px;
`;

export const Heading = styled.h1`
  margin: 0;
  color: ${COLOR.textPrimary};
  ${textStyles.titleMedium700}
`;

export const Tip = styled.p<{ $color?: COLOR }>`
  margin: 0;
  color: ${(props) => props.$color ?? COLOR.textSecondary};
  ${textStyles.bodyMedium450}
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const BottomLink = styled.div`
  padding-top: 20px;
  text-align: center;
  ${font.size(14)}
  a {
    display: inline-block;
    padding: 3px 0;
    ${mixins.link()}
  }
`;
